module.exports = __webpack_public_path__ + "img/nav-right-with-contact-hyundai-expanded.881950fb.jpg";